import { render } from "./ProductDetail_EconomicResponsibilityAudit.vue?vue&type=template&id=0d1f8d14&scoped=true"
import script from "./ProductDetail_EconomicResponsibilityAudit.vue?vue&type=script&lang=js"
export * from "./ProductDetail_EconomicResponsibilityAudit.vue?vue&type=script&lang=js"

import "./ProductDetail_EconomicResponsibilityAudit.vue?vue&type=style&index=0&id=0d1f8d14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1f8d14"]])

export default __exports__